import { render } from "./DoughnutChartCard.vue?vue&type=template&id=4de7c246"
import script from "./DoughnutChartCard.vue?vue&type=script&lang=js"
export * from "./DoughnutChartCard.vue?vue&type=script&lang=js"

import "./DoughnutChartCard.vue?vue&type=style&index=0&id=4de7c246&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__